var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAzure = function SvgAzure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_svg__a)",
    d: "M8.34 7.955h7.401L8.058 31.222a1.2 1.2 0 0 1-.43.595c-.2.147-.442.226-.689.226H1.18a1.16 1.16 0 0 1-.538-.133 1.191 1.191 0 0 1-.628-.893 1.233 1.233 0 0 1 .049-.564l7.16-21.677c.078-.24.228-.447.43-.594.2-.147.441-.226.688-.226v-.001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M19.096 23.562H7.358a.536.536 0 0 0-.506.35.565.565 0 0 0 .135.61l7.543 7.194c.22.21.508.326.809.326h6.646l-2.89-8.482v.002Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_svg__b)",
    d: "M8.34 7.955c-.25 0-.493.08-.695.23-.202.15-.351.363-.426.606L.07 30.435a1.224 1.224 0 0 0 .146 1.1c.11.157.254.287.422.375.168.089.354.135.543.134h5.91c.22-.04.425-.139.595-.287.17-.148.3-.34.373-.555l1.426-4.293 5.091 4.854c.213.18.481.28.758.282h6.622l-2.905-8.482-8.465.002 5.181-15.61H8.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_svg__c)",
    d: "M17.794 8.775a1.205 1.205 0 0 0-.43-.594c-.2-.147-.44-.226-.687-.226h-8.25c.248 0 .487.08.688.226.2.147.35.355.43.594l7.159 21.68a1.222 1.222 0 0 1-.58 1.456c-.166.087-.35.133-.537.133h8.249a1.159 1.159 0 0 0 .957-.502 1.231 1.231 0 0 0 .16-1.088l-7.16-21.68Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_svg__a",
    x1: 11.038,
    x2: 3.044,
    y1: 9.741,
    y2: 32.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_svg__b",
    x1: 13.438,
    x2: 11.652,
    y1: 20.556,
    y2: 21.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_svg__c",
    x1: 12.516,
    x2: 21.281,
    y1: 9.042,
    y2: 31.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
};
export default SvgAzure;